import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatIconModule } from '@angular/material/icon'
import { MatButtonModule } from '@angular/material/button'
import { CommonModule } from '@angular/common'
import { MatDividerModule } from '@angular/material/divider'
import { Route, Router, RouterModule } from '@angular/router'
import { RouteService } from '../../services/route.service'
import { Dialog } from '@angular/cdk/dialog'
import { AuthService } from '../../services/auth.service'
import { DialogService } from '../../services/dialog.service'
import { ErrorService } from '../../services/error.service'
import { SpinnerService } from '../../services/spinner.service'
import { ApiError } from '../../types/apiError'
import { firstValueFrom } from 'rxjs/internal/firstValueFrom'
import { TranslationService } from '../../services/translation.service'
import { CANADIAN_PROVINCES } from '../../constants/provinces'
import { LocationService } from '../../services/location.service'
@Component({
  selector: 'app-side-menu',
  imports: [
    CommonModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    RouterModule,
  ],
  templateUrl: './side-menu.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './side-menu.component.scss',
})
export class SideMenuComponent implements OnInit {
  @Input() visible: boolean = false
  @Output() toggleSideMenu = new EventEmitter<null>()

  router = inject(Router)
  authService = inject(AuthService)
  spinnerService = inject(SpinnerService)
  errorService = inject(ErrorService)
  dialogService = inject(DialogService)
  dialog = inject(Dialog)
  routeService = inject(RouteService)
  translationService = inject(TranslationService)
  locationService = inject(LocationService)
  currentRoute: Route | undefined

  locationName: string = CANADIAN_PROVINCES[0].name

  ngOnInit(): void {
    const locationFromLS = this.locationService.getLocationFromLS()

    if (locationFromLS?.country === 'Canada') {
      this.locationName = locationFromLS?.province ?? CANADIAN_PROVINCES[0].name
    } else {
      if (locationFromLS?.country) {
        this.locationName = locationFromLS?.country
      }
    }
  }

  /**
   * Updates the current navigation context referenced in this component
   */
  updateCurrentRoute() {
    this.currentRoute = this.routeService.getRoute()
  }

  /**
   * Hides sidebar
   */
  hideSideMenu() {
    this.toggleSideMenu.emit()
  }

  /**
   * Reroutes user to login page
   */
  goToLogin() {
    this.hideSideMenu()
    this.router.navigate(['/auth/login'])
  }

  /**
   * Logs user out and reroutes them to the home page
   */
  async logout() {
    try {
      this.spinnerService.startSpinner()
      await firstValueFrom(this.authService.logout())
      this.spinnerService.stopSpinner()
      this.hideSideMenu()
      this.router.navigate([''])
    } catch (err) {
      this.spinnerService.stopSpinner()
      const apiErr = err as ApiError
      this.errorService.handleErr(this.dialogService, apiErr, this.dialog)
    }
  }

  /**
   * Routes user to specified route
   */
  goToRoute(path: string | undefined) {
    if (path) {
      this.router.navigate([path])
      this.hideSideMenu()
      this.updateCurrentRoute()
    }
  }

  hideMenuAndShowLocationDialog() {
    this.hideSideMenu()
    this.locationService.showLocationDialog(this.dialog)
  }
}
